import { CourseTrack } from './models';

export function isPartOfLearningTrack(
  courseTrack: CourseTrack | null | undefined,
  useRedesignCatalog: boolean,
): boolean {
  return useRedesignCatalog && !!courseTrack?.learning_track_id;
}

export function learningTrackHeaderTitle(
  courseTrack: CourseTrack | null | undefined,
  useRedesignCatalog: boolean,
): string {
  return isPartOfLearningTrack(courseTrack, useRedesignCatalog)
    ? (courseTrack?.learning_track_name ?? '')
    : (courseTrack?.name ?? '');
}

export function learningTrackCoursesCompleted(courseTrack: CourseTrack | null | undefined): number {
  return courseTrack?.learning_track_completed_courses ?? 0;
}

export function learningTrackCoursesTotal(courseTrack: CourseTrack | null | undefined): number {
  return courseTrack?.learning_track_total_courses ?? 0;
}

// next_course_track_id can point outside the current learning track even after
// every course in it is done, so treat this as the authoritative signal instead.
export function hasCompletedLearningTrack(courseTrack: CourseTrack | null | undefined): boolean {
  const total = learningTrackCoursesTotal(courseTrack);
  return total > 0 && learningTrackCoursesCompleted(courseTrack) >= total;
}
